<template>
  <v-row>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;"> {{ i18n.visas_access }} </span>
      <br />
      <span> {{ transform(visa.visas_access, "bool") }} </span>
    </v-col>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;"> {{ i18n.visa_appointment }} </span>
      <br />
      <div v-if="visa.visa_appointment">
        <v-chip small dark color="blue">
          {{ formatDateToCurrentLocale(visa.visa_appointment)[0] }}
        </v-chip>
        <v-chip small dark color="blue" class="ml-1">
          {{ formatDateToCurrentLocale(visa.visa_appointment)[1] }}
        </v-chip>
      </div>
      <div v-else>Not set</div>
    </v-col>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.visa_application_ready }}
      </span>
      <br />
      <span> {{ transform(visa.visa_application_ready, "bool") }} </span>
    </v-col>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.visa_application_submitted }}
      </span>
      <br />
      <span> {{ transform(visa.visa_application_submitted, "bool") }} </span>
    </v-col>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;"> {{ i18n.visa_granted }} </span>
      <br />
      <span> {{ transform(visa.visa_granted, "bool") }} </span>
    </v-col>
    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3" v-if="visa.visa_granted_document">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.visa_granted_document }}
      </span>
      <br />
      <div class="text-truncate" style="max-width: 100%; display: inline-block">
        {{ transform(visa.visa_granted_document.url, "string") }}
      </div>
      <div>
        <v-btn
          color="orange"
          dark
          class="mr-2"
          x-small
          prepend-icon=""
          @click.prevent="() => clipboard(visa.visa_granted_document.url)"
        >
          
          {{ i18n.copy}}
          <v-icon size="14" class="ml-1">link</v-icon>
        </v-btn>
        <v-btn link :href="visa.visa_granted_document.url" target="_blank" dark color="blue darken-1" x-small class="ml-1">
          {{ i18n.open }}
          <v-icon size="14" class="ml-1">open_in_new</v-icon>
        </v-btn>
      </div>
    </v-col>

    <!-- Missing visa values -->

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.accelerated_procedure_documents_ready }}
      </span>
      <br />
      <span> {{ transform(visa.accelerated_procedure_documents_ready, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.accelerated_procedure_result }}
      </span>
      <br />
      <span> {{ transform(visa.accelerated_procedure_result, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3" v-if="visa.accelerated_procedure_result_document">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.accelerated_procedure_result_document }}
      </span>
      <br />
      <div class="text-truncate" style="max-width: 100%; display: inline-block">
        {{ transform(visa.accelerated_procedure_result_document.url, "string") }}
      </div>
      <div>
        <v-btn
          color="orange"
          dark
          class="mr-2"
          x-small
          prepend-icon=""
          @click.prevent="() => clipboard(visa.accelerated_procedure_result_document.url)"
        >
          
          {{ i18n.copy}}
          <v-icon size="14" class="ml-1">link</v-icon>
        </v-btn>
        <v-btn link :href="visa.accelerated_procedure_result_document.url" target="_blank" dark color="blue darken-1" x-small class="ml-1">
          {{ i18n.open }}
          <v-icon size="14" class="ml-1">open_in_new</v-icon>
        </v-btn>
      </div>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.accelerated_procedure_submitted }}
      </span>
      <br />
      <span> {{ transform(visa.accelerated_procedure_submitted, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.ba_documents_ready }}
      </span>
      <br />
      <span> {{ transform(visa.ba_documents_ready, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;"> {{ i18n.ba_result }} </span>
      <br />
      <span> {{ transform(visa.ba_result, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3" v-if="visa.ba_result_document">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.ba_result_document }}
      </span>
      <br />
      <div class="text-truncate" style="max-width: 100%; display: inline-block">
        {{ transform(visa.ba_result_document.url, "string") }}
      </div>
      <div>
        <v-btn
          color="orange"
          dark
          class="mr-2"
          x-small
          prepend-icon=""
          @click.prevent="() => clipboard(visa.ba_result_document.url)"
        >
          
          {{ i18n.copy}}
          <v-icon size="14" class="ml-1">link</v-icon>
        </v-btn>
        <v-btn link :href="visa.ba_result_document.url" target="_blank" dark color="blue darken-1" x-small class="ml-1">
          {{ i18n.open }}
          <v-icon size="14" class="ml-1">open_in_new</v-icon>
        </v-btn>
      </div>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;"> {{ i18n.ba_submitted }} </span>
      <br />
      <span> {{ transform(visa.ba_submitted, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3" v-if="visa.airline_ticket_document">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.airline_ticket_document }}
      </span>
      <br />
      <div class="text-truncate" style="max-width: 100%; display: inline-block">
        {{ transform(visa.airline_ticket_document.url, "string") }}
      </div>
      <div>
        <v-btn
          color="orange"
          dark
          class="mr-2"
          x-small
          prepend-icon=""
          @click.prevent="() => clipboard(visa.airline_ticket_document.url)"
        >
          
          {{ i18n.copy}}
          <v-icon size="14" class="ml-1">link</v-icon>
        </v-btn>
        <v-btn link :href="visa.airline_ticket_document.url" target="_blank" dark color="blue darken-1" x-small class="ml-1">
          {{ i18n.open }}
          <v-icon size="14" class="ml-1">open_in_new</v-icon>
        </v-btn>
      </div>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="6" md="3">
      <span style="font-size: 12px; font-weight: 700; text-transform: capitalize;">
        {{ i18n.booked_airline_ticket }}
      </span>
      <br />
      <span> {{ transform(visa.booked_airline_ticket, "bool") }} </span>
    </v-col>

    <v-col :class="`${arabic ? 'arFont' : 'enFont'}`" cols="12">
      <v-btn small color="primary" @click.prevent="editResource">Edit</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["resource", "updatedResource"],
  data() {
    return {
      visa: {
        id: null,
        visas_access: null,
        visa_appointment: null,
        visa_appointment: null,
        visa_appointment: null,
        visa_application_ready: null,
        visa_application_submitted: null,
        visa_granted: null,
        visa_granted_document_id: null,
        accelerated_procedure_documents_ready: null,
        accelerated_procedure_result: null,
        accelerated_procedure_result_document_id: null,
        accelerated_procedure_submitted: null,
        ba_documents_ready: null,
        ba_result: null,
        ba_result_document_id: null,
        ba_submitted: null,
        airline_ticket_document_id: null,
        booked_airline_ticket: null,
        accelerated_procedure_result_document: null,
        ba_result_document: null,
        visa_granted_document: null,
        airline_ticket_document: null,
      },
    };
  },
  watch: {
    resource: {
      immediate: true,
      handler(value) {
        Object.keys(this.visa).map((key) => {
          this.visa[key] = value[key];
        });
      },
      deep: true,
    },
    updatedResource: {
      immediate: true,
      handler(value) {
        if (value) {
          Object.keys(this.visa).map((key) => {
            this.visa[key] = value[key];
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    clipboard(str) {
      navigator.clipboard.writeText(str);
      this.$emit("copyS");
    },
    editResource() {
      const editable_resource = Object.keys(this.visa).reduce((acc, curr) => {
        if (typeof this.visa[curr] == "object") {
          acc[curr] = this.visa[curr] ? this.visa[curr].url : "";
        } else {
          acc[curr] = this.visa[curr];
        }

        return acc;
      }, {});

      this.$emit("editResource", "visa", editable_resource);
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    transform(value, to) {
      switch (to) {
        case "bool":
          return Boolean(value) ? "Yes" : "No";
        case "number":
          return value;
        case "string":
          return value;
      }
    },
  },
  computed: {
    visaKeys() {
      return Object.keys(this.resource).filter((key) => key.startsWith("visa_"));
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
};
</script>
